var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWpfName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64443 7.33873C7.57104 7.31473 7.1072 7.10565 7.39704 6.22457H7.39289C8.14843 5.44642 8.72581 4.19427 8.72581 2.9615C8.72581 1.06596 7.46535 0.0722656 6.00043 0.0722656C4.53458 0.0722656 3.28104 1.0655 3.28104 2.9615C3.28104 4.19934 3.8552 5.45657 4.61535 6.23288C4.91166 7.01011 4.38181 7.29857 4.27104 7.33919C2.73689 7.89396 0.93689 8.90519 0.93689 9.9035V10.2778C0.93689 11.638 3.57412 11.9472 6.01474 11.9472C8.45904 11.9472 11.063 11.638 11.063 10.2778V9.9035C11.063 8.87519 9.25427 7.8718 7.64443 7.33873Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpfName);
export default __webpack_public_path__ + "static/media/wpf_name.b6a84065dd9e2d3b7cc85862a2634df2.svg";
export { ForwardRef as ReactComponent };